import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from './store'
import axios from 'axios'
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import settings from "./assets/js/settings";
import cookies from 'vue-cookies'
import '@/assets/css/global.css'
import '../public/admin/components/ueditor/ueditor.config'
import '../public/admin/components/ueditor/ueditor.all.js'
import '../public/admin/components/ueditor/lang/zh-cn/zh-cn.js'
import '../public/admin/components/ueditor/ueditor.parse.min.js'


Vue.prototype.$cookies = cookies
import http from './lib/http'
import global from './global'

Vue.prototype.$settings = settings
Vue.prototype.$axios = axios
Vue.prototype.$http = http
// require('./mock')
Vue.config.productionTip = false
Vue.use(ElementUI);

const isExamPage = () => window.location.pathname === '/StudentExam'
const RUNTIME_ERROR_STORAGE_KEY = 'seaforest_runtime_errors'
const RUNTIME_ERROR_LIMIT = 30
const HTTP_TRACE_LIMIT = 20
const CLIENT_ERROR_ENDPOINT = `${settings.SITE_ORIGIN}/api/v1/client_error/`
const recentHttpEvents = []

const makeRuntimeErrorId = () => {
    return `SF-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
}

const clipText = (value, maxLength = 2000) => {
    if (value === undefined || value === null) {
        return ''
    }
    const text = typeof value === 'string' ? value : JSON.stringify(value)
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}

const readCurrentUser = () => {
    try {
        const userinfo = cookies.get('userinfo') || {}
        return {
            user_id: userinfo.user_id || userinfo.id || '',
            username: userinfo.username || '',
            role: userinfo.role,
        }
    } catch (e) {
        return {}
    }
}

const getBrowserMeta = () => {
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        online: navigator.onLine,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        screen: window.screen ? `${window.screen.width}x${window.screen.height}` : '',
    }
}

const trackHttpEvent = (event) => {
    try {
        recentHttpEvents.unshift(Object.assign({
            time: new Date().toISOString(),
        }, event || {}))
        recentHttpEvents.splice(HTTP_TRACE_LIMIT)
    } catch (e) {
        console.warn('[http trace failed]', e)
    }
}

const sendRuntimeError = (item) => {
    try {
        const body = JSON.stringify(item)
        if (navigator.sendBeacon) {
            const blob = new Blob([body], {type: 'application/json'})
            if (navigator.sendBeacon(CLIENT_ERROR_ENDPOINT, blob)) {
                return
            }
        }
        fetch(CLIENT_ERROR_ENDPOINT, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body,
            keepalive: true,
        }).catch(error => {
            console.warn('[runtime report failed]', error)
        })
    } catch (error) {
        console.warn('[runtime report failed]', error)
    }
}

const normalizeRuntimePayload = (payload) => {
    const safePayload = payload || {}
    return {
        id: safePayload.id || makeRuntimeErrorId(),
        time: new Date().toISOString(),
        path: window.location.href,
        source: safePayload.source || 'unknown',
        message: safePayload.message || '未知前端异常',
        info: safePayload.info || '',
        stack: clipText(safePayload.stack || (safePayload.error && safePayload.error.stack) || '', 6000),
        http: safePayload.http || null,
        user: readCurrentUser(),
        browser: getBrowserMeta(),
        recentHttp: recentHttpEvents.slice(0, HTTP_TRACE_LIMIT),
    }
}

const recordRuntimeError = (payload) => {
    const item = normalizeRuntimePayload(payload)
    try {
        const oldItems = JSON.parse(localStorage.getItem(RUNTIME_ERROR_STORAGE_KEY) || '[]')
        oldItems.unshift(item)
        localStorage.setItem(RUNTIME_ERROR_STORAGE_KEY, JSON.stringify(oldItems.slice(0, RUNTIME_ERROR_LIMIT)))
    } catch (e) {
        console.error('[runtime log write failed]', e)
    }
    console.error('[runtime log]', item)
    sendRuntimeError(item)
    return item
}

window.__SEAF_RECORD_RUNTIME_ERROR__ = recordRuntimeError
window.__SEAF_TRACK_HTTP__ = trackHttpEvent
window.__SEAF_GET_RUNTIME_ERRORS__ = function () {
    try {
        return JSON.parse(localStorage.getItem(RUNTIME_ERROR_STORAGE_KEY) || '[]')
    } catch (e) {
        return []
    }
}

const reportRuntimeError = (payload) => {
    const item = recordRuntimeError(payload)
    if (isExamPage()) {
        console.error('[exam runtime error suppressed]', item)
        return
    }
    window.dispatchEvent(new CustomEvent('app-runtime-error', {
        detail: item
    }))
}

window.__SEAF_REPORT_RUNTIME_ERROR__ = reportRuntimeError

Vue.config.errorHandler = (error, vm, info) => {
    console.error(error)
    reportRuntimeError({
        source: 'vue',
        message: (error && error.message) || '页面运行异常',
        info,
        stack: error && error.stack,
    })
}

window.onerror = function (message, source, lineno, colno, error) {
    recordRuntimeError({
        source: 'window',
        message,
        info: `${source || ''}:${lineno || ''}:${colno || ''}`,
        stack: error && error.stack,
    })
    console.error('[window error suppressed]', {
        message,
        source,
        line: lineno,
        column: colno,
        error
    })
    return true
}

window.onunhandledrejection = function (event) {
    let reason = event && event.reason
    if (event.preventDefault) {
        event.preventDefault()
    }
    if (reason && (reason.__handledByHttp || reason.__ignoreRuntimeReport)) {
        console.warn('[handled promise rejection suppressed]', reason)
        return false
    }
    recordRuntimeError({
        source: 'promise',
        message: (reason && reason.message) || String(reason || 'Promise rejection'),
        stack: reason && reason.stack,
    })
    console.error('[promise rejection suppressed]', reason)
    return false
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
